<template>
  <div align="center">
    <table
      width="100%"
      border="0"
      align="center"
      cellspacing="0"
      cellpadding="0"
    >
      <tbody>
        <tr>
          <td align="center" height="130">
            <table width="90%" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                <tr>
                  <td align="left" width="60%">
                    <a target="_blank" onfocus="this.blur();"
                      ><img
                        :style="global.isPhone() ? 'width:100%;' : ''"
                        border="0"
                        src="/static/img/logo.png"
                    /></a>
                  </td>
                  <td align="right" width="40%">
                    <nav class="nav">
                      <ul class="nav_menu">
                        <li class="nav_menu-item" id="yss17">
                          <a
                            onfocus="this.blur();"
                            :class="global.isPhone() ? '' : 'a2'"
                            :href="global.remoteIp"
                            >继续查询</a
                          >
                        </li>
                        <!-- <li class="nav_menu-item" id="yss23"><a onfocus="this.blur();" class="a1"
                            href="">返回首页</a>
                        </li>  -->
                      </ul>
                    </nav>
                  </td>
                </tr>
                <tr></tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td align="center" bgcolor="#5789d0" height="75">
            <table width="90%" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                <tr>
                  <td
                    align="left"
                    :style="
                      global.isPhone()
                        ? 'color:#FFFFFF;font-size:16px;'
                        : 'color:#FFFFFF;font-size:20px;'
                    "
                  >
                    当前位置：<a
                      class="bai"
                      href="http://www.cnzk.org.cn/"
                      onfocus="this.blur();"
                      >首页</a
                    >- 查询结果 - [&nbsp;<font color="#FFFFFF">{{
                      resText
                    }}</font
                    >&nbsp;]
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        <tr>
          <td align="center" bgcolor="#e0effa">
            <table
              :width="global.isPhone() ? '90%' : '60%'"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <tbody>
                <tr>
                  <td
                    align="left"
                    valign="top"
                    style="padding-top:15px;padding-bottom:20px;"
                  >
                    <table
                      width="100%"
                      border="0"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        <tr>
                          <td valign="top" align="left">
                            <table
                              width="100%"
                              border="0"
                              cellspacing="0"
                              cellpadding="0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <table
                                      bgcolor="#FFFFFF"
                                      style="border:1px dashed #CCC9BD; font-size:16px;"
                                      width="100%"
                                      border="0"
                                      cellspacing="0"
                                      cellpadding="0"
                                    >
                                      <tbody>
                                        <tr v-if="certtype == 'person'">
                                          <td>
                                            <table
                                              width="100%"
                                              class="content"
                                              cellpadding="0"
                                              cellspacing="0"
                                            >
                                              <tbody>
                                                <tr bgcolor="#c1e1f8">
                                                  <td
                                                    height="55"
                                                    :align="
                                                      global.isPhone()
                                                        ? 'center'
                                                        : 'left'
                                                    "
                                                    style="border-right:1px #ddd solid; font-weight: 600;font-size:20px"
                                                    colspan="4"
                                                  >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;基本信息
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    姓&nbsp;&nbsp;&nbsp;&nbsp;名
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.name }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    性&nbsp;&nbsp;&nbsp;&nbsp;别
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.sex }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    出生日期
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.birthday }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    身份证号
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.cardtid }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    学历学位
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.edu }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    联系方式
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.contacts }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    工作单位
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    {{ cert.company }}
                                                  </td>
                                                </tr>
                                                <tr bgcolor="#c1e1f8">
                                                  <td
                                                    height="55"
                                                    :align="
                                                      global.isPhone()
                                                        ? 'center'
                                                        : 'left'
                                                    "
                                                    style="border-right:1px #ddd solid;font-weight: 600;font-size:20px"
                                                    colspan="4"
                                                  >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;证书信息
                                                  </td>
                                                </tr>

                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid; "
                                                  >
                                                    专业名称
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    {{ cert.position }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    专业等级
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.level }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    考试成绩
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.grade }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    证书编号
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.code }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    发证日期
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.certtime }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    技术支持
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    认证信息查询网
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    发证机关
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    {{ cert.issuedagency }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    机关网址
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    <a :href="cert.issuedurl">{{
                                                      cert.issuedurl
                                                    }}</a>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr v-if="certtype == 'company'">
                                          <td>
                                            <table
                                              width="100%"
                                              class="content"
                                              cellpadding="0"
                                              cellspacing="0"
                                            >
                                              <tbody>
                                                <tr bgcolor="#c1e1f8">
                                                  <td
                                                    height="55"
                                                    :align="
                                                      global.isPhone()
                                                        ? 'center'
                                                        : 'left'
                                                    "
                                                    style="border-right:1px #ddd solid; font-weight: 600;font-size:20px"
                                                    colspan="4"
                                                  >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;基本信息
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    单位名称
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    {{ cert.companyname }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    法定代表人
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.legalperson }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    注册资金
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.registeredcapital }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    企业类型
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.companytype }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    信用代码
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.socilacredit }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    注册地址
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    {{ cert.registeredaddress }}
                                                  </td>
                                                </tr>
                                                <tr bgcolor="#c1e1f8">
                                                  <td
                                                    height="55"
                                                    :align="
                                                      global.isPhone()
                                                        ? 'center'
                                                        : 'left'
                                                    "
                                                    style="border-right:1px #ddd solid;font-weight: 600;font-size:20px"
                                                    colspan="4"
                                                  >
                                                    &nbsp;&nbsp;&nbsp;&nbsp;证书信息
                                                  </td>
                                                </tr>

                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid; "
                                                  >
                                                    专业名称
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    {{ cert.professionaltitle }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    专业等级
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.professionallevel }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    证书编号
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.code }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    发证日期
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.certtime }}
                                                  </td>
                                                  <td
                                                    width="10%"
                                                    align="center"
                                                    class="tdtitle"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    有效日期
                                                  </td>
                                                  <td
                                                    width="40%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                  >
                                                    {{ cert.validtime }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    技术支持
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    认证信息查询网
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    发证机关
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    {{ cert.issuedagency }}
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    机关网址
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    <a :href="cert.issuedurl">{{
                                                      cert.issuedurl
                                                    }}</a>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td
                                                    height="45"
                                                    width="10%"
                                                    class="tdtitle"
                                                    align="center"
                                                    style="border-right:1px #ddd solid;"
                                                  >
                                                    年检记录
                                                  </td>
                                                  <td
                                                    width="90%"
                                                    align="left"
                                                    style="border-right:1px #ddd solid;padding: 5px;"
                                                    colspan="3"
                                                  >
                                                    <div
                                                      v-if="
                                                        cert.inspectrecord &&
                                                          cert.inspectrecord.indexOf(
                                                            '第一年'
                                                          ) > -1
                                                      "
                                                      style="margin-left: 30px;"
                                                    >
                                                      <img
                                                        :src="
                                                          `${global.remoteIp}/uploads/sealpic.jpg`
                                                        "
                                                        width="150px"
                                                      />
                                                      <p
                                                        style="font-size: 18px;font-weight: 900;margin-left: 43px;"
                                                      >
                                                        已年审
                                                      </p>
                                                    </div>
                                                    <div
                                                      v-if="
                                                        cert.inspectrecord &&
                                                          cert.inspectrecord.indexOf(
                                                            '第二年'
                                                          ) > -1
                                                      "
                                                      style="margin-left: 30px;"
                                                    >
                                                      <img
                                                        :src="
                                                          `${global.remoteIp}/uploads/sealpic.jpg`
                                                        "
                                                        width="150px"
                                                      />
                                                      <p
                                                        style="font-size: 18px;font-weight: 900;margin-left: 43px;"
                                                      >
                                                        已年审
                                                      </p>
                                                    </div>
                                                    <div
                                                      v-if="
                                                        cert.inspectrecord &&
                                                          cert.inspectrecord.indexOf(
                                                            '第三年'
                                                          ) > -1
                                                      "
                                                      style="margin-left: 30px;"
                                                    >
                                                      <img
                                                        :src="
                                                          `${global.remoteIp}/uploads/sealpic.jpg`
                                                        "
                                                        width="150px"
                                                      />
                                                      <p
                                                        style="font-size: 18px;font-weight: 900;margin-left: 43px;"
                                                      >
                                                        已年审
                                                      </p>
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            style="padding:0px 0 30px 0px;"
                                            v-if="result == false"
                                          >
                                            <center>
                                              <br /><br /><br />
                                              &nbsp;未查询到任何信息！请确认输入信息是否正确！<br /><br /><br />
                                            </center>
                                          </td>
                                          <td></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style="padding:30px 0 20px 0;" bgcolor="#5789d0" align="center">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                <tr>
                  <td
                    align="center"
                    style="line-height:32px;font-size:15px;color:#FFFFFF;"
                  >
                    佰标认证信息查询网<br />
                    信用服务机构业务备案号：JS010704003<br />Copyright &#169;
                    2016-2021 zgxxw.org.cn Allright sreserved.
                    <a
                      onfocus="this.blur();"
                      class="bai"
                      target="_blank"
                      href="https://beian.miit.gov.cn/"
                      >京ICP备16059480号-1</a
                    ><br />
                    <table>
                      <tbody>
                        <tr></tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { Message } from "element-ui";
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {},
  components: {},
  data() {
    return {
      cert: {},
      result: false,
      resText: "未查询到信息",
      certtype: "",
      global,
    };
  },

  created() {},

  methods: {},

  computed: {},

  mounted() {
    let code = this.$route.query.code;
    let name = this.$route.query.name;
    let type = this.$route.query.type;
    let url = "";
    if (type == "company") {
      url = `/api/companyCertificates/userget?code=${code}&companyname=${name}`;
    } else {
      url = `/api/certificates/userget?code=${code}&name=${name}`;
    }
    this.$axios
      .get(encodeURI(url))
      .then((res) => {
        if (res.data.data.length > 0) {
          this.cert = res.data.data[0];
          if (this.cert.birthday && this.cert.birthday.indexOf(".") > -1) {
            this.cert.birthday =
              this.cert.birthday.slice(0, 4) +
              "年" +
              this.cert.birthday.slice(5, 7) +
              "月" +
              this.cert.birthday.slice(8, 10) +
              "日";
          }
          let certtime = this.cert.certtime;
          if(certtime.indexOf(".")>-1)
          {
            let arrtime = certtime.split(".");
            this.cert.certtime = arrtime[0]+'年'+arrtime[1]+"月"+arrtime[2]+"日"
          }
          // let validtime = this.cert.validtime;
          // if(validtime.indexOf(".")>-1)
          // {
          //   let arrtime = validtime.split(".");
          //   this.cert.validtime = arrtime[0]+'年'+arrtime[1]+"月"+arrtime[2]+"日"
          // }
          this.result = true;
          this.resText = "证书编号：" + this.cert.code;
          console.log("this.certtype", this.certtype);
          if (type == "company") {
            this.certtype = "company";
          } else {
            this.certtype = "person";
          }

          return;
        } else {
          this.result = false;
          return;
        }
      })
      .catch((err) => {
        this.result = false;
      });
  },

  watch: {},
};
</script>
<style scoped>
.content {
  border-collapse: collapse;
}
.content tr td {
  border: 1px solid #d4dedd;
}
.tdtitle {
  min-width: 90px;
  background-color: #eaf4fb;
  font-weight: 600;
}
</style>
